import { createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../../../shared/theme/theme';

export const snackBarTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          color: globalTheme.palette.appWhite.main,
          padding: '16px',
          lineHeight: 1,

          '&.error': {
            backgroundColor: globalTheme.palette.error.dark,
          },

          '&.success': {
            backgroundColor: globalTheme.palette.primary.main,
          },

          '& .alert-icon': {
            display: 'flex',
            alignItems: 'center',
          },
        },
      },
    },
  },
});
